/**
 * Prefilled by the seed and by both owner-facing forms, never a database
 * DEFAULT: a creation path that renders no form must keep storing NULL,
 * which means unlimited.
 */
export const DEFAULT_BOOKING_WINDOW_DAYS = 60;

export const MIN_BOOKING_WINDOW_DAYS = 1;

export const MAX_BOOKING_WINDOW_DAYS = 365;

export const MAX_DURATION_MINUTES = 7 * 24 * 60;

export const MAX_BUFFER_MINUTES = 24 * 60;

export const MAX_MINIMUM_NOTICE_MINUTES = 365 * 24 * 60;

export const APPOINTMENT_TYPE_MINUTE_CAPS = {
  duration_minutes: MAX_DURATION_MINUTES,
  buffer_before_minutes: MAX_BUFFER_MINUTES,
  buffer_after_minutes: MAX_BUFFER_MINUTES,
  minimum_notice_minutes: MAX_MINIMUM_NOTICE_MINUTES,
} as const;

export type CappedMinuteField = keyof typeof APPOINTMENT_TYPE_MINUTE_CAPS;

export const CAPPED_MINUTE_FIELDS = Object.keys(
  APPOINTMENT_TYPE_MINUTE_CAPS,
) as CappedMinuteField[];

export const LOCATION_TYPES = [
  'none',
  'google_meet',
  'in_person',
  'phone',
  'customer_address',
  'custom',
] as const;

export type LocationType = (typeof LOCATION_TYPES)[number];
